module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "develteam-announcements"
    }
  }, [_c('h1', [_vm._v("Develteam Announcements")]), _vm._v(" "), _vm._l((_vm.announcements), function(announcement) {
    return _c('div', [_c('h2', [_vm._v(_vm._s(announcement.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(announcement.text))]), _vm._v(" "), (announcement.link) ? _c('p', [_vm._v("\n            Go to the "), _c('router-link', {
      attrs: {
        "to": announcement.link
      }
    }, [_vm._v(_vm._s(announcement.linkText))])], 1) : _vm._e()])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64196ad5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/HomeDashboard/Announcements.vue
// module id = 881
// module chunks = 2